import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';
import {AwsCredentials} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {

  //FOLDER = 'users/';
  constructor() { }

  async uploadFile(file,fileName,FOLDER) {


    // const contentType = file.type;
    // const bucket = new S3({
    //   accessKeyId: 'AKIAXKHCZONWFVAG23DM',
    //   secretAccessKey: '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',
    //   region: 'ap-south-1'
    // });

    // const params = {
    //   Bucket: 'marketplacedayandnight',
    //   Key: FOLDER + fileName,
    //   Body: file,
    //   ACL: 'public-read',
    //   ContentType: contentType
    // };

    // const response =await  bucket.upload(params, function (err, data) {
    //     if (err) {
    //         // console.log('There was an error uploading your file: ', err);
    //         return false;
    //     }
    //     console.log('Successfully uploaded file.', data);
    //     return data;
    // });

    // return response;

    // resolve reject approach working

    return new Promise((resolve,reject)=>{

      const loader = document.getElementById('loader-class');
      if(loader){
          console.log('inside loader');
        loader.style.display = 'block';
      }

      const contentType = file.type;
      const bucket = new S3({
        accessKeyId: AwsCredentials.S3_accessKeyId,
        secretAccessKey: AwsCredentials.S3_secretAccessKey,
        region: AwsCredentials.S3_region,
      });

      const params = {
        Bucket: AwsCredentials.S3_BUCKET,
        maxRetries: 2,
        Key: FOLDER + fileName,
        Body: file,
        ACL: 'public-read',
        ContentType: contentType,
        partSize: 10 * 1024 * 1024,
        queueSize: 1,
        httpOptions: { timeout: 360000 }
      };

      const response = bucket.upload(params, function (err, data) {
          if (err) {
              reject(err);
          }
          console.log('Successfully uploaded file.', data);
          if(loader){
            loader.style.display = 'none';
          }
          resolve(data);
      });
    })

    // bucket.deleteObject(params, function (err, data) {
    //   if (err) {
    //     console.log('There was an error deleting your file: ', err.message);
    //     return;
    //   }
    //   console.log('Successfully deleted file.');
    // });

    // return false;


      //for upload progress
      /*bucket.upload(params).on('httpUploadProgress', function (evt) {
            console.log(evt.loaded + ' of ' + evt.total + ' Bytes');
        }).send(function (err, data) {
            if (err) {
                console.log('There was an error uploading your file: ', err);
                return false;
            }
            console.log('Successfully uploaded file.', data);
            return true;
        });*/
  }


  removeFile(file,FOLDER) {
    const contentType = file.type;
    const bucket = new S3({
      accessKeyId:AwsCredentials.S3_accessKeyId,
      secretAccessKey: AwsCredentials.S3_secretAccessKey,
      region: AwsCredentials.S3_region
    });

    const params = {
      Bucket: AwsCredentials.S3_BUCKET,
      Key: FOLDER + file.name,
      // Body: file,
      // ACL: 'public-read',
      // ContentType: contentType
    };

   bucket.deleteObject(params, function (err, data) {
      if (err) {
        console.log('There was an error deleting your file: ', err.message);
        return;
      }
      console.log(data);
      console.log('Successfully deleted file.');
    });

    return false;


  }
}
